import { createUseStyles } from 'react-jss';

import { Spacings } from '@picsart/design-system/foundation/spacings';

const useStyles = createUseStyles(
  {
    scrollArea: {
      height: '100%',
      width: '100%',
      overflowY: 'scroll',
      scrollSnapType: 'y mandatory',
      overscrollBehavior: 'contain',
      scrollbarWidth: 'none',
      '&::-webkit-scrollbar': {
        display: 'none',
      },
    },
    slide: {
      position: 'relative',
      height: '100%',
      width: '100%',
      scrollSnapAlign: 'start',
      scrollSnapStop: 'always',
    },
    slideActionBar: {
      position: 'absolute',
      left: 0,
      right: 0,
      bottom: 0,
      // Explicit rather than relying on DOM order. The media below is a
      // carousel whose track animates, and an animating transform gets its own
      // compositor layer — paint order among z-index:auto siblings is then the
      // browser's overlap testing to get right, and in a WebView it does not.
      // Every card overlay already states its layer (CARD_Z_*); this was the
      // one that did not.
      zIndex: 1,
      padding: [Spacings.s48, Spacings.s12],
      paddingBottom: `max(${Spacings.s24}, env(safe-area-inset-bottom))`,
    },
  },
  { name: 'feed-slide-list' }
);

export default useStyles;
